export const siteSettings = {
  name: "Hub Central Markets",
  link: "https://hubcentralmarkets.net",
  email: "support@hubcentralmarkets.net",
  appLink: "https://app.hubcentralmarkets.net",
};
